/* Galaxy partner-logo marquee — JS-driven, seamless on every device (2026-09-27)

   WHY NOT THE CSS KEYFRAME
   The old strip used `animation: translateX(0 -> -50%)` on a width:max-content track
   holding four cloned sets. That is seamless only if every set is EXACTLY the same
   width for the whole life of the animation. It is not:
     - the clone logos were loading="lazy", so on a cold load (Windows Chrome/Edge
       especially) sets 2-4 measured with the <img width=260> placeholder, then
       re-laid-out narrower once the real files arrived, mid-animation. -50% of a
       width that just changed = a visible jump / blank gap.
     - font/zoom rounding leaves sets at fractional widths (e.g. 1445.75px); -50% of
       the whole track is not the same as an exact set boundary -> hairline seam.

   THIS VERSION
   - Eager-loads the logos, waits for them, measures ONE set (setW = width + gap),
     then clones enough sets to cover twice the viewport, and moves the track with
     requestAnimationFrame at a constant px/s. Position wraps with `x % setW`, so the
     loop point is always an exact set boundary — no seam, no gap, any width.
   - Re-measures on resize and whenever the first set's size changes (ResizeObserver),
     so a late image or a zoom change cannot desync it.
   - Pauses on hover / focus-within (as before), and when the tab is hidden the
     timestamp delta is clamped so it does not leap on return.
   - Honours prefers-reduced-motion: leaves the CSS static layout alone.
*/
(function () {
  if (window.__gxBrands) return; window.__gxBrands = 1;

  var SPEED = 34;          // px per second (matches the old 84s / 2 sets pace)
  var MAX_DT = 50;         // ms; clamp frame gaps (tab switch, jank) so no leaps

  function init(wrap) {
    var track = wrap.querySelector('.brands-track');
    var first = track && track.querySelector('.brands-set');
    if (!track || !first) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    wrap.classList.add('brands--js');
    track.style.animation = 'none';

    /* logos must be real before we measure */
    track.querySelectorAll('img').forEach(function (img) { img.loading = 'eager'; });

    var setW = 0, x = 0, last = 0, paused = false, raf = 0;

    function gapOf(el) {
      var g = parseFloat(getComputedStyle(el).paddingRight) || 0;
      return g;
    }

    function measure() {
      var w = first.getBoundingClientRect().width;   // includes its own padding-right (the gap)
      if (w < 10) return false;
      setW = w;
      /* enough clones to cover the viewport twice, so the wrap is never visible */
      var need = Math.ceil((wrap.clientWidth * 2) / setW) + 1;
      var sets = track.querySelectorAll('.brands-set');
      for (var i = sets.length; i < need; i++) {
        var c = first.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.querySelectorAll('a').forEach(function (a) { a.tabIndex = -1; });
        c.querySelectorAll('img').forEach(function (im) { im.alt = ''; });
        track.appendChild(c);
      }
      return true;
    }

    function frame(now) {
      raf = requestAnimationFrame(frame);
      if (!last) { last = now; return; }
      var dt = Math.min(MAX_DT, now - last); last = now;
      if (paused || !setW) return;
      x += SPEED * dt / 1000;
      if (x >= setW) x -= setW;                      // exact set boundary: seamless
      track.style.transform = 'translate3d(' + (-x) + 'px,0,0)';
    }

    function start() {
      if (!measure()) { setTimeout(start, 120); return; }
      if (!raf) raf = requestAnimationFrame(frame);
    }

    wrap.addEventListener('mouseenter', function () { paused = true; });
    wrap.addEventListener('mouseleave', function () { paused = false; });
    wrap.addEventListener('focusin', function () { paused = true; });
    wrap.addEventListener('focusout', function () { paused = false; });
    document.addEventListener('visibilitychange', function () { last = 0; });

    if (window.ResizeObserver) {
      new ResizeObserver(function () { if (measure() && x >= setW) x = x % setW; }).observe(first);
      new ResizeObserver(function () { measure(); }).observe(wrap);
    } else {
      window.addEventListener('resize', measure);
    }

    /* wait for the logos in the first set, then go */
    var imgs = Array.prototype.slice.call(first.querySelectorAll('img'));
    var pending = imgs.filter(function (i) { return !i.complete; }).length;
    if (!pending) start();
    else imgs.forEach(function (i) {
      if (i.complete) return;
      var done = function () { if (--pending <= 0) start(); };
      i.addEventListener('load', done, { once: true });
      i.addEventListener('error', done, { once: true });
    });
    setTimeout(start, 1500);   // safety: never wait forever on a stalled image
  }

  function boot() {
    document.querySelectorAll('.brands--marquee').forEach(function (w) {
      if (!w.dataset.gxInit) { w.dataset.gxInit = '1'; init(w); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
